export default __webpack_public_path__ + "static/media/41fc8173ba2f5edf0ceb15abd1f3fe481576092936509.eb5415de.webp";